// Fetch live browser credentials before the SDK or any map component starts.
let loading;
export function loadAMap () {
  if (loading) return loading
  loading = new Promise((resolve, reject) => {
    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), 8000)
    fetch('https://yuanhuihuanhuan.com/operation/api/system/amap-config/public', { cache: 'no-store', signal: controller.signal })
      .then(r => { if (!r.ok) throw new Error('地图配置获取失败'); return r.json() })
      .then(r => {
        clearTimeout(timer)
        if (r.status !== 200 || !r.data || !/^[a-f0-9]{32}$/i.test(r.data.jsKey)) throw new Error('网页地图Key未配置')
        window._AMapSecurityConfig = { securityJsCode: r.data.securityJsCode }
        const script = document.createElement('script')
        const timeout = setTimeout(() => { script.remove(); reject(new Error('高德地图加载超时，请刷新重试')) }, 12000)
        window.__amapReady = () => {
          clearTimeout(timeout)
          if (!window.AMap || !window.AMap.Map) return reject(new Error('高德地图初始化失败'))
          resolve(window.AMap)
        }
        script.onerror = () => { clearTimeout(timeout); script.remove(); reject(new Error('高德地图加载失败')) }
        script.src = 'https://webapi.amap.com/maps?v=2.0&key=' + encodeURIComponent(r.data.jsKey) + '&plugin=AMap.Scale,AMap.ToolBar,AMap.Geolocation,AMap.Driving&callback=__amapReady'
        document.head.appendChild(script)
      }).catch(error => { clearTimeout(timer); reject(error) })
  })
  return loading
}

